import { onFilterMenuIsOpenChanged } from '../actions/publicActions';
import { assertNever } from '@uifabric/utilities';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem } from 'owa-filterable-menu';
import strings from 'owa-strings/owa-photo-hub-strings';
import {
    IContextualMenuItem,
    ContextualMenuItemType,
    IContextualMenuProps,
} from 'office-ui-fabric-react/lib/ContextualMenu';
import {
    getFileExtensionContextMenuItems,
    IsFileExtensionSelectedFuncType,
    IsFileExtensionsExpandedFuncType,
} from './getFileExtensionContextMenuItems';
import {
    getDateRangeContextMentuItems,
    IsDateRangeOptionSelectedFuncType,
} from './getDateRangeContextMenuItems';

export enum FilesFilterContextMenuType {
    Files,
    Images,
}

export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.Images,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.Files,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded: IsFileExtensionsExpandedFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected?: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded?: IsFileExtensionsExpandedFuncType
) {
    let items;
    switch (filesFilterContextMenuType) {
        case FilesFilterContextMenuType.Images:
            items = getDateRangeContextMentuItems(isDateRangeOptionSelectedCheck);
            break;
        case FilesFilterContextMenuType.Files:
            items = [
                ...getFileExtensionContextMenuItems(isExtensionSelected, isExtensionFilterExpanded),
                getDivider(),
                ...getDateRangeContextMentuItems(isDateRangeOptionSelectedCheck),
            ];
            break;
        default:
            assertNever(filesFilterContextMenuType);
    }

    const menu: IContextualMenuProps = {
        onMenuOpened: () => onFilterMenuIsOpenChanged(true),
        onMenuDismissed: () => onFilterMenuIsOpenChanged(false),
        items: items,
    };
    const menuItem = new FilterableMenuItem(
        strings.filterText /* name */,
        ControlIcons.Filter /* icon */,
        () => {} /* onClick */,
        () => true /* shouldShow */,
        DisplayOption.Left /* displayOption */,
        false /* disabled */,
        menu
    );
    return menuItem;
}

function getDivider(): IContextualMenuItem {
    return {
        key: 'extension_date_divider',
        itemType: ContextualMenuItemType.Divider,
    };
}
